import fetchJsonp from 'fetch-jsonp';

// セットサンプル月上限超過および在庫チェック、単独カートリンク設置
class SampleZaiko {
  constructor(cont) {
    this.$ = cont;

    // サンプルセットJAN
    this.shohincd = this.$.dataset.shohincd;

    // ドメイン判定
    this.location = location;
    this.domain = this.location.host;
    let host = '';
    if (this.domain.indexOf("shiseido.co.jp") != -1) {
      host = this.location.protocol + '//' + this.domain;
    } else {
      host = 'https://www.shiseido.co.jp'
    }
    this.host = host;

    // サンプル上限API
    this.apiSamplePath = "/sw/api/auth/V1/SWFR040050.seam";
    this.apiSampleURL = this.host + this.apiSamplePath;

    // 在庫API
    this.apiZaikoPath = "/sw/products/SWFG070740.seam";
    this.apiZaikoURL = this.host + this.apiZaikoPath;

    this.apiParam = '?shohin_cd=';

    // コールバックURL
    let callBackURL = this.host + location.pathname;
    if (callBackURL.indexOf('index.html') === -1) callBackURL += 'index.html';
    this.callBackURL = callBackURL;

    this.initialize();

  }

  async initialize() {

    // 上限判定文字列初期化
    let sampleJogen = '';

    // サンプル上限判定（０：未超過、１：超過、２：想定外）
    let sampleJogenData;
    await fetchJsonp(this.apiSampleURL + this.apiParam + this.shohincd)
      .then(function (response) {
        return response.json();
      }).then(function (json) {
        sampleJogenData = json;
      }).catch(function (error) {
        sampleJogen = '0';
      });
    sampleJogen = sampleJogenData.map(function (value) {
      let jogenData;
      if (value.jogen_choka_kbn == 0) {
        // 未超過
        jogenData = 1;
      } else if (value.jogen_choka_kbn == 1 || value.jogen_choka_kbn == 2){
        // 超過 or 想定外JAN
        jogenData = 0;
      }
      return jogenData;
    });

    // 在庫判定文字列初期化
    let sampleZaiko = '';

    // サンプル在庫判定（０：品切れ、１：在庫あり、２：在庫わずか、９：完売）
    let sampleZaikoData = '';
    await fetchJsonp(this.apiZaikoURL + this.apiParam + this.shohincd + '&border=20&shohin_kbn=2&zk_kbn=2')
      .then(function (response) {
        return response.json();
      }).then(function (json) {
        sampleZaikoData = json;
      }).catch(function (error) {
        sampleZaiko = '0';
      });
    sampleZaiko = sampleZaikoData.map(function (value) {
      return value.zaiko_kbn;
    });

    console.log('sampleZaiko', sampleZaiko, 'sampleJogen', sampleJogen)

    // 在庫がなかったら、上限を超過と同じ対応にする
    if(sampleZaiko == 0 || sampleZaiko == 9){
      sampleJogen = 0;
    }

    // 該当要素表示
    const displayTarget = Array.from(this.$.querySelectorAll('.sample_zaikokbn' + sampleJogen));
    displayTarget.forEach(elm => {
      elm.style.display = 'block';
    })

    // 単独カートリンク設置＆ClickID設定
    this.cartBaseURL = this.host + "/sw/products/auth/SWFG044100.seam?sweb_shohin_cd=" + this.shohincd + '&setsmpl_lp_url=' + this.callBackURL;
    if (this.$.querySelector('.js-sample-cart-link')) {
      this.cartLinkArr = Array.from(this.$.querySelectorAll('.js-sample-cart-link'));
      this.cartLinkArr.forEach((link) => {
        link.href = this.cartBaseURL;
        link.setAttribute('onclick', '_sc.gene_click(\'cartbtn_' + this.shohincd + '_' + this.$.dataset.sample_serial + '\',this.href);');
      })
    }

  }

}

// DOM取得・判定実行
const cartButtons = document.querySelectorAll('.js-sample-zaiko');
const sampleZaikoFlag = 'zaiko-completed';
const sampleZaikocb = function (entries, observer) {
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      if (!entry.target.classList.contains(sampleZaikoFlag)) {
        new SampleZaiko(entry.target);
        entry.target.classList.add(sampleZaikoFlag);
      }
      observer.unobserve(entry.target);
    }
  });
};
const sampleZaikoIOoptions = {
  root: null,
  rootMargin: "100px",
  threshold: 0
};
const sampleZaikoIO = new IntersectionObserver(sampleZaikocb, sampleZaikoIOoptions);
if (cartButtons) {
  cartButtons.forEach((cart, index) => {
    cart.setAttribute('data-sample_serial', index + 1);
    sampleZaikoIO.observe(cart);
  });
}


// マルチカート設定
class sampleMultiCart {
  constructor(){
    this.janArray = [];
    this.maxNum = 2; //一度にカートに入れる上限数
    this.checkButtons = Array.from(document.querySelectorAll('.js-sample-check'));
    this.checkedClass = 'is-checked';
    this.multiCart = document.querySelector('.js-sample-multi-cart');
    this.multiCartLink = document.querySelector('.js-sample-multi-cart-link');
    this.cartShowClass = 'is-show';
    if (this.multiCart){
      this.bind();
    }

    // ドメイン判定
    this.location = location;
    this.domain = this.location.host;
    let host = '';
    if (this.domain.indexOf("shiseido.co.jp") != -1) {
      host = this.location.protocol + '//' + this.domain;
    } else {
      host = 'https://www.shiseido.co.jp'
    }
    this.host = host;

    // コールバックURL
    let callBackURL = this.host + location.pathname;
    if (callBackURL.indexOf('index.html') === -1) callBackURL += 'index.html';
    this.callBackURL = callBackURL;

  }

  bind(){
    this.checkButtons.forEach((button) => {
      button.addEventListener('click', this.checkButtonClick.bind(this));
    });
  }

  checkButtonClick = function(event){
    console.log(event.target);
    const thisButton = event.target;
    const thisJAN = thisButton.closest('.js-sample-zaiko').dataset.shohincd;
    const thisDisabled = thisButton.disabled;
    if (thisButton.classList.contains(this.checkedClass)) {
      // チェック済み
      this.janArray = this.janArray.filter((value) => {
        return value != thisJAN;
      })
      thisButton.classList.remove(this.checkedClass);
      this.checkButtons.forEach((button) => {
        button.disabled = false;
      })
      if (this.janArray.length === 0) {
        this.multiCart.classList.remove(this.cartShowClass);
      } else {
        this.cartLinkSet();
      }
    } else {
      // 未チェック
      this.janArray.push(thisJAN);
      thisButton.classList.add(this.checkedClass);
      if (this.multiCart){
        this.multiCart.classList.add(this.cartShowClass);
      }
      if (this.janArray.length >= this.maxNum) {
        const unCheckedButtons = Array.from(document.querySelectorAll('.js-sample-check:not(.is-checked)'));
        unCheckedButtons.forEach((button) => {
          button.disabled = true;
        });
      }
      this.cartLinkSet();
    }
  }

  cartLinkSet() {
    const cartParameter = this.janArray.join('&sweb_shohin_cd=');
    const onClickId = 'cartbtn_' + this.janArray.join('_');
    console.log(cartParameter, onClickId, this.callBackURL);

    this.cartBaseURL = this.host + "/sw/products/auth/SWFG044100.seam?sweb_shohin_cd=" + cartParameter + '&setsmpl_lp_url=' + this.callBackURL;
    if (this.multiCartLink) {
      this.multiCartLink.href = this.cartBaseURL;
      this.multiCartLink.setAttribute('onclick', '_sc.gene_click(\'' + onClickId + '\',this.href);');
    }
    console.log(this.janArray);
  }
}

new sampleMultiCart();
